import { PageAction } from './';

export class PageActionEventArgs {
    public element: HTMLElement;
    public action: PageAction;
    public cancel: boolean = false;

    constructor(element: HTMLElement, action: PageAction) {
        this.element = element;
        this.action = action;
    }
}
